import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const ROLE_SHOW = "role/show";

export const showRole = createAsyncThunk(ROLE_SHOW, async (thunkAPI) => {
  try {
    const dataSource = new DataSource({
      store: new ODataStore({
        url: `${baseUrl}Role`,
        key: "Oid",
        version: 4,
        beforeSend: (request) => {
          request.headers["token"] = token;
          request.headers["MappedState"] = 1;
        },
      }),
    });
    return dataSource;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});
